module.exports = __webpack_public_path__ + "static/media/Ordkjedetest_eksempler-start.fd8d238d.m4a";